import { render, staticRenderFns } from "./comment_templates_dropdown.vue?vue&type=template&id=b3e4d37e"
import script from "./comment_templates_dropdown.vue?vue&type=script&lang=js"
export * from "./comment_templates_dropdown.vue?vue&type=script&lang=js"
import style0 from "./comment_templates_dropdown.vue?vue&type=style&index=0&id=b3e4d37e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports